import { format } from 'date-fns';
import { useAdminCompanies } from '@/api/queries/superAdmin.queries';
import { PageHeader } from '@/components/shared/PageHeader';
import { Badge } from '@/components/ui/badge';

const PLAN_BADGE = { BASIC: 'default', PRO: 'blue', CUSTOM: 'purple' };

export default function SuperAdminBasicUsersPage() {
  const { data, isLoading } = useAdminCompanies('BASIC');
  const companies = data?.data ?? [];

  return (
    <div className="space-y-5 fade-in max-w-5xl">
      <PageHeader
        title="Basic Registered Users"
        subtitle={`${companies.length} ${companies.length === 1 ? 'company' : 'companies'} currently on the free Basic plan`}
        breadcrumb={[{ label: 'Super Admin', href: '/super-admin' }, { label: 'Basic Users' }]}
      />

      <div className="card overflow-hidden p-0">
        {isLoading ? (
          <p className="text-[13px] text-[var(--text-secondary)] p-6 text-center">Loading…</p>
        ) : companies.length === 0 ? (
          <p className="text-[13px] text-[var(--text-secondary)] p-6 text-center">No companies on Basic right now.</p>
        ) : (
          <table className="w-full text-[13px]">
            <thead>
              <tr className="border-b border-[var(--border)] text-left">
                <th className="px-5 py-3 font-semibold text-[var(--text-secondary)]">Company</th>
                <th className="px-5 py-3 font-semibold text-[var(--text-secondary)]">Owner</th>
                <th className="px-5 py-3 font-semibold text-[var(--text-secondary)]">Phone</th>
                <th className="px-5 py-3 font-semibold text-[var(--text-secondary)]">State</th>
                <th className="px-5 py-3 font-semibold text-[var(--text-secondary)]">Plan</th>
                <th className="px-5 py-3 font-semibold text-[var(--text-secondary)]">Signed up</th>
              </tr>
            </thead>
            <tbody>
              {companies.map(c => (
                <tr key={c.id} className="border-b border-[var(--border)] last:border-0 hover:bg-[var(--bg-hover)] transition-colors">
                  <td className="px-5 py-3 font-semibold text-[var(--text-primary)]">{c.name}</td>
                  <td className="px-5 py-3 text-[var(--text-secondary)]">{c.owner?.name || '—'}</td>
                  <td className="px-5 py-3 text-[var(--text-secondary)]">{c.owner?.phone || '—'}</td>
                  <td className="px-5 py-3 text-[var(--text-secondary)]">{c.state || '—'}</td>
                  <td className="px-5 py-3"><Badge variant={PLAN_BADGE[c.plan] || 'default'}>{c.plan || 'BASIC'}</Badge></td>
                  <td className="px-5 py-3 text-[var(--text-tertiary)]">{c.created_at ? format(new Date(c.created_at), 'd MMM yyyy') : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
